import Vue from "vue";
import VueRouter from "vue-router";
import { validarToken } from "../services/autenticacion";
import Modulos from "../services/modulos";
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Login",
		component: () => import("../views/Login.vue")
	},
	{
		path: "/nutricion",
		name: "Principal",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/Principal.vue"),
		children: [
			{
				path: "pacientes",
				name: "Pacientes",
				component: () => import("../views/pacientes/Pacientes.vue")
			},
			{
				path: "nuevo-paciente",
				name: "Nuevo Paciente",
				component: () => import("../views/pacientes/NuevoPaciente.vue")
			},
			{
				path: "editar-paciente/:pacienteId",
				name: "Editar Paciente",
				component: () => import("../views/pacientes/NuevoPaciente.vue")
			},
			{
				path: "perfil-paciente/:pacienteId/:visitaId?",
				name: "Perfil Paciente",
				component: () => import("../views/pacientes/PerfilPaciente.vue")
			},
			{
				path: "historial-clinico/:historiaClinicaId",
				name: "Historial Clínico",
				component: () =>
					import(
						"../views/pacientes/historial-clinico/HistorialClinico.vue"
					)
			},
			{
				path: "visita/:visitaId",
				name: "Visita",
				component: () => import("../views/pacientes/visita/Visita.vue"),
				children: [
					{
						path: "antropometria",
						name: "Antropometría",
						component: () =>
							import(
								"../views/pacientes/visita/Antropometria.vue"
							)
					},
					{
						path: "bioquimicos",
						name: "Bioquímicos",
						component: () =>
							import("../views/pacientes/visita/Bioquimicos.vue")
					},
					{
						path: "clinicos",
						name: "Clínicos",
						component: () =>
							import("../views/pacientes/visita/Clinicos.vue")
					},
					{
						path: "dieteticos-y-estilo-vida",
						name: "Dietéticos y Estilo de Vida",
						component: () =>
							import(
								"../views/pacientes/visita/DieteticosYEstiloVida.vue"
							)
					},
					{
						path: "analisis-y-plan-terapeutico",
						name: "Análisis y Plan Terapéutico",
						component: () =>
							import(
								"../views/pacientes/visita/AnalisisYPlanTerapeutico.vue"
							)
					},
					{
						path: "nota-evolucion-interna",
						name: "Nota de Evolución Interna",
						component: () =>
							import(
								"../views/pacientes/visita/NotaEvolucionInterna.vue"
							)
					},
					{
						path: "nota-evolucion-firma",
						name: "Nota de Evolución",
						component: () =>
							import(
								"../views/pacientes/visita/NotaEvolucionFirma.vue"
							)
					},
					{
						path: "nota-evolucion-medico",
						name: "Nota de Evolución",
						component: () =>
							import(
								"../views/pacientes/visita/NotaEvolucionMedico.vue"
							)
					}
				]
			}
		]
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

router.beforeEach(async (to, _from, next) => {
	if (to.name !== "Login" && !localStorage.getItem("jwt")) {
		next("/");
	} else if (to.name !== "Login") {
		const module = Modulos.find(
			m => to.fullPath.toLowerCase().indexOf(m.Router.toLowerCase()) > -1
		);
		if (!module) {
			next();
		} else {
			const permisos = JSON.parse(localStorage.getItem("modulos"));
			if (permisos.some(p => p === module.ModuloID)) {
				next();
			} else {
				next("/");
			}
		}
	} else {
		/*else if (to.name !== 'Login') {
    try {
      const res = await validarToken();
      if (
        res.data.result !== 1 ||
        !res.data.data.Table0.length ||
        !res.data.data.Table0[0].jti
      ) {
        localStorage.removeItem('jwt');
        next('/');
      } else {
        next();
      }
    } catch (err) {
      localStorage.removeItem('jwt');
      next('/');
    }
  }*/
		next();
	}
});

export default router;
